import { motion } from "framer-motion";
import Section from "./Section";
import { images, translations, type Lang } from "../content";

export default function About({ lang }: { lang: Lang }) {
  const t = translations[lang];
  const rtl = lang === "he";

  return (
    <Section id="about">
      {/* Text and bus sit side by side, each taking half the width. */}
      <div
        className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center"
        dir={rtl ? "rtl" : "ltr"}
      >
        <div>
          <h2 className="display-lg text-4xl md:text-5xl text-foreground mb-6">
            {t.about.title}
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-light">
            {t.about.text}
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, x: rtl ? -40 : 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <img
            src={images.aboutBus}
            alt="S.T.Y. Travel fleet"
            className="w-full h-auto object-contain opacity-90 transition-opacity duration-700 hover:opacity-100"
          />
        </motion.div>
      </div>
    </Section>
  );
}
